import "./mainStyles.scss";
import React from "react";

const paragraphFirst = "1. Наша система знижок прямо залежить від об’єму, замовленого вами товару. Знижки починаються від 100 л добрива “Агроболік”, від 10 т добрива “Агротеїн”, від 3 кубів РКД та від 50 посівних одиниць.";
const paragraphSecond = "2. Надавши відгук з фото або відео про нашу компанію та товари, ви отримаєте персональну знижку на наступне замовлення.";
const paragraphThird = "3. Порадьте нашу компанію іншим людям та отримаєте персональну знижку на наступне замовлення.";
const paragraphFourst = "1. Залишіть вашу заявку на сайті";
const paragraphFifth = "2. Напишіть вашу пропозицію на пошту: sunberry.ukr@gmail.com";
const paragraphSixth = "3. Зателефонуйте за номером: +38 (068) 369 90 30";

const data = [
    {
        title: "Як отримати знижку ?",
        paragraphFirst,
        paragraphSecond,
        paragraphThird,
    },
    {
        title: "Хочете співпрацювати з нашою компанією ?",
        paragraphFourst,
        paragraphFifth,
        paragraphSixth,
    },
    {
        title: "Хочете замовити добриво з особливими складовими ?",
        thirdCard:
            "Наша компанія спеціалізується на створенні складно змішаних добрив, тому можемо задовольнити майже будь-які ваші потреби.",
    },
    {
        title: "Чи можлива відстрочка платежу за товар та кредитування ?",
        fourthCard:
            "Ми націлені на тісні взаємозв’язки. Залишайте заявку на сайті — консультант зв’яжеться з вами.",
    },
    {
        title: "Не обрали, що саме Вам підходить з добрив ?",
        fifthCard:
            "Зверніться за телефоном: 068 369 90 30 — менеджер підкаже оптимальне рішення.",
    },
    {
        title: "Чи можна розрахуватись готівкою чи переказом на картку ?",
        sixthCard: "Так, ми приймаємо будь-який вид оплат.",
    },
    {
        title: "При яких умовах можливе повернення товару ?",
        seventhCard:
            "Повернення можливе на умовах, зазначених у договорі між сторонами.",
    },
];

export default function FAQ() {
    return (
        <div className="accordion__wrapper">
            <div className="faq__titleBlock">
                <h2 className="faq__title">
                    Відповіді на <br />
                    <span>поширені запитання</span>
                </h2>
            </div>

            <ul className="accordion-list">
                {data.map((item, idx) => (
                    <li className="accordion-list__item" key={idx}>
                        <AccordionItem {...item} idx={idx} />
                    </li>
                ))}
            </ul>
        </div>
    );
}

class AccordionItem extends React.Component {
    state = { opened: this.props.idx === 0 }; // перший відкритий, як на макеті

    toggle = () => this.setState((s) => ({ opened: !s.opened }));

    onKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.toggle();
        }
    };

    render() {
        const {
            title,
            paragraphFirst,
            paragraphSecond,
            paragraphThird,
            paragraphFourst,
            paragraphFifth,
            paragraphSixth,
            thirdCard,
            fourthCard,
            fifthCard,
            sixthCard,
            seventhCard,
            idx,
        } = this.props;

        const { opened } = this.state;
        const panelId = `faq-panel-${idx}`;
        const btnId = `faq-btn-${idx}`;

        return (
            <div className={`accordion-item ${opened ? "accordion-item--opened" : ""}`}>
                <div className="accordion-item__line">
                    <h3 className="accordion-item__title">{title}</h3>

                    {/* кнопка з плюсом, доступна з клавіатури/скрінрідера */}
                    <button
                        id={btnId}
                        className="accordion-item__iconBtn"
                        aria-expanded={opened}
                        aria-controls={panelId}
                        onClick={this.toggle}
                        onKeyDown={this.onKeyDown}
                        type="button"
                    >
                        <span className="visually-hidden">{opened ? "Згорнути" : "Розгорнути"}</span>
                        <span className="plusIcon" aria-hidden="true" />
                    </button>
                </div>

                <div
                    id={panelId}
                    role="region"
                    aria-labelledby={btnId}
                    className="accordion-item__inner"
                >
                    <div className="accordion-item__content">
                        <p className="accordion-item__paragraph">
                            {paragraphFirst && (
                                <span className="accordion-item__paragraph--position">{paragraphFirst}</span>
                            )}
                            {paragraphSecond && (
                                <span className="accordion-item__paragraph--position">{paragraphSecond}</span>
                            )}
                            {paragraphThird && (
                                <span className="accordion-item__paragraph--position">{paragraphThird}</span>
                            )}
                            {paragraphFourst && (
                                <span className="accordion-item__paragraph--position">{paragraphFourst}</span>
                            )}
                            {paragraphFifth && (
                                <span className="accordion-item__paragraph--position">{paragraphFifth}</span>
                            )}
                            {paragraphSixth && (
                                <span className="accordion-item__paragraph--position">{paragraphSixth}</span>
                            )}
                            {thirdCard}
                            {fourthCard}
                            {fifthCard}
                            {sixthCard}
                            {seventhCard}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
